import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Mat } from "@techstark/opencv-js";
import RondonPressureViewerComponent, { reverseImageData, RondonPressureViewerComponentHandler } from "./RondonPressureViewerComponent";
import { useDesignStore } from "context/DesignContext";
import toast from "react-hot-toast";
import cv from "@techstark/opencv-js";
import { useApi } from 'context/ApiProvider';
import { useSelectedDesignStore } from "context/SelectedDesignContext";
import { PressureImage } from "models/Insole";
import { RONDOM_PRESSUURE_PIXEL_WIDTH } from "components/Viewer3d/RondomConsts";
import { useTheme as useAppTheme } from "context/ThemeContext";

interface RondomScanViewerProps {
    isOpen: boolean;
    onClose: () => void;
}

interface Metadata {
    [key: string]: string;
}
interface DataRow {
    [key: string]: string;
}

function getUniqueXValues(datarows: DataRow[]): number[] {
    const xValues = datarows.map(row => parseFloat(row.X));
    const uniqueXBuffer = Array.from(new Set(xValues));
    uniqueXBuffer.sort((a, b) => a - b);
    const min = uniqueXBuffer[0];
    const max = uniqueXBuffer[uniqueXBuffer.length - 1];
    const distanceBetweenSensor = 0.762;
    const allColumns = ((max - min) / distanceBetweenSensor) + 1;
    const margin = 2
    const uniqueX = Array.from({ length: allColumns }, () => 0);
    for (let i = 0; i < (allColumns + margin * 2); i++) {
        uniqueX[i] = min + ((i - margin) * distanceBetweenSensor);
    }
    return uniqueX;
}

function getUniqueYValues(datarows: DataRow[]): number[] {

    const xValues = datarows.map(row => parseFloat(row.Y));
    const uniqueXBuffer = Array.from(new Set(xValues));
    uniqueXBuffer.sort((a, b) => a - b);
    const min = uniqueXBuffer[0];
    const max = uniqueXBuffer[uniqueXBuffer.length - 1];
    const distanceBetweenSensor = 0.762;
    const allColumns = ((max - min) / distanceBetweenSensor) + 1;
    const margin = 2
    const uniqueX = Array.from({ length: allColumns }, () => 0);
    for (let i = 0; i < (allColumns + margin * 2); i++) {
        uniqueX[i] = min + ((i - margin) * distanceBetweenSensor);
    }
    return uniqueX;
}

function getTotalFrames(datarows: DataRow[]): number[] {
    const xValues = datarows.map(row => parseFloat(row['Beelden']));
    const uniqueXBuffer = Array.from(new Set(xValues));
    uniqueXBuffer.sort((a, b) => a - b);

    return uniqueXBuffer;
}

function findIndex(val: number, reference: number[]): number {
    let closestIndex = 0;
    let smallDiff = Math.abs(val - reference[0]);

    for (let i = 0; i < reference.length; i++) {
        const diff = Math.abs(val - reference[i]);
        if (diff < smallDiff) {
            smallDiff = diff;
            closestIndex = i;
        }
    }
    return closestIndex;
}

function matrixToMat(matrix: number[][]): any {
    const rows = matrix.length;
    const cols = matrix[0]?.length || 0;

    // Flatten the 2D array
    const flatArray = new Uint16Array(rows * cols);
    for (let i = 0; i < rows; i++) {
        for (let j = 0; j < cols; j++) {
            flatArray[i * cols + j] = matrix[i][j];
        }
    }

    // Create a cv.Mat with type CV_32F
    const mat = new cv.Mat(rows, cols, cv.CV_16U);
    mat.data16U.set(flatArray);

    return mat;
}

const RondomScanViewer: React.FC<RondomScanViewerProps> = ({isOpen, onClose}) => {

    const [leftFile, setLeftFile] = useState('');
    const [rightFile, setRightFile] = useState('');
    const [leftImage, setLeftImage] = useState<Mat | undefined>(undefined);
    const [rightImage, setRightImage] = useState<Mat | undefined>(undefined);
    const rightMaxFrameRef = useRef<Mat | undefined>(undefined);
    const leftMaxFrameRef = useRef<Mat | undefined>(undefined);
    const rightFramesRef = useRef<Mat[] | undefined>(undefined);
    const leftFramesRef = useRef<Mat[] | undefined>(undefined);

    const rightRondomViewerRef = useRef<RondonPressureViewerComponentHandler>(null);
    const leftRondomViewerRef = useRef<RondonPressureViewerComponentHandler>(null);

    const [rightFileName, setRightFileName] = useState<string>('No file selected');
    const [leftFileName, setLeftFileName] = useState<string>('No file selected');

    const showFrames = useRef<Mat | undefined>(undefined);

    const rightIntervalRef = useRef<NodeJS.Timeout | null>(null);
    const rightFrames = useRef<Mat[]>([]);
    const rightCurrentFrame = useRef<number>(0);

    const leftIntervalRef = useRef<NodeJS.Timeout | null>(null);
    const leftFrames = useRef<Mat[]>([]);
    const leftCurrentFrame = useRef<number>(0);

    const rightFileRef = useRef('');
    const leftFileRef = useRef('');

    const insoleDesign = useDesignStore((state) => state.insoleDesign);
    const [animationClass, setAnimationClass] = useState('');
    const { isDarkMode } = useAppTheme();

    const api = useApi();
    
     useEffect(() => {
        if (isOpen) {
          const initialize = async () => {
            // if (insoleDesign?.designType === 'Template') {
            //   const previousDesign = useDesignStore.getState().previousDesign;
            //   if (!previousDesign) return;
            //   try {
            //       applyTemplate(insoleDesign, previousDesign);
            //   } catch (err) {
            //     console.error('Error handling template dialog:', err);
            //   }
            // }
          };
          initialize();
          setAnimationClass('scan-panel-visible');
        } 
        else{
            setAnimationClass('scan-panel-hidden');
        }
      }, [isOpen]);
    
      if (!isOpen && animationClass === 'scan-panel-hidden') {
        return null;
      }

    // useEffect(() => {

    //     // if (isOpen) {
    //     //     if (rightFileRef.current !== rightFile) loadCSV(rightFile, true);
    //     //     if (leftFileRef.current !== leftFile) loadCSV(leftFile, false);
    //     // }
    //     // rightFileRef.current = rightFile;
    //     // leftFileRef.current = leftFile;

    // }, [isOpen, leftFile, rightFile]);

    const readCSV = async (source: File, fileName: string): Promise<Mat[]> => {

        const readFrames: Mat[] = [];
        try {
            let text = await new Promise<string>((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const result = e.target?.result;
                    if (typeof result === "string") resolve(result);
                    else reject(new Error('Failed to read file as text'));
                };
                reader.onerror = () => reject(reader.error);
                reader.readAsText(source);
            });

            const lines = text.split('\n')
                .map((line) => line.trim())
                .filter(line => line !== '');
            const metaHeaders = lines[0].split(';');
            const metaValues = lines[1].split(';');

            const dataHeaders = lines[2].split(';');
            const dataLines = lines.slice(3);
            const dataObject: DataRow[] = dataLines.map((line) => {
                const values = line.split(';');
                const row: DataRow = {};
                dataHeaders.forEach((key, i) => {
                    row[key] = values[i];
                });
                return row;
            });

            const frameIndices = getTotalFrames(dataObject);
            const xData: number[] = getUniqueXValues(dataObject);
            const yData: number[] = getUniqueYValues(dataObject);

            for (let i = 0; i < frameIndices.length; i++) {
                const frameData = dataObject.filter((row) => row['Beelden'] == frameIndices[i]);

                const matrix: number[][] = Array.from({ length: yData.length }, () =>
                    Array.from({ length: xData.length }, () => 0)
                );

                frameData.forEach((row) => {
                    const x = parseFloat(row.X);
                    const y = parseFloat(row.Y);

                    // const i = xData.indexOf(x);
                    // const j = yData.indexOf(y);
                    const i = findIndex(x, xData);
                    const j = findIndex(y, yData);

                    let val: number = 0;
                    if (fileName.includes('Mean')) val = parseInt(row['Gemiddelde druk (Kpa)']);
                    else if (fileName.includes('Max')) val = parseInt(row['Maximale druk (Kpa)']);
                    else if (fileName.includes('Video')) val = parseInt(row['Druk (Kpa)']);
                    matrix[j][i] = val;
                });

                const rawMat: Mat = matrixToMat(matrix);
                readFrames.push(rawMat);
            }
        }
        catch {

        }
        return readFrames;
    }

    const loadCSV = async (source: string | File, fileName: string, isRight: boolean) => {
        try {

            if (isRight) {
                if (rightIntervalRef.current) {
                    clearInterval(rightIntervalRef.current);
                    rightIntervalRef.current = null;
                }
                rightFrames.current.forEach(element => element.delete());
                rightFrames.current = [];
            }
            else {
                if (leftIntervalRef.current) {
                    clearInterval(leftIntervalRef.current);
                    leftIntervalRef.current = null;
                }
                leftFrames.current.forEach(element => element.delete());
                leftFrames.current = [];
            }

            if (!source || (typeof source === 'string' && source === '')) {

                if (isRight) setRightImage(undefined);
                else setLeftImage(undefined);
                return;
            }

            let text: string;
            if (typeof source === "string") {
                const response = await fetch(source);
                text = await response.text();
            }
            else {
                text = await new Promise<string>((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const result = e.target?.result;
                        if (typeof result === "string") resolve(result);
                        else reject(new Error('Failed to read file as text'));
                    };
                    reader.onerror = () => reject(reader.error);
                    reader.readAsText(source);
                });
            }


            const lines = text.split('\n')
                .map((line) => line.trim())
                .filter(line => line !== '');

            const metaHeaders = lines[0].split(';');
            const metaValues = lines[1].split(';');
            const metsdataObj: Metadata = metaHeaders.reduce((acc, key, index) => {
                acc[key] = metaValues[index];
                return acc;
            }, {} as Metadata);


            const dataHeaders = lines[2].split(';');
            const dataLines = lines.slice(3);
            const dataObject: DataRow[] = dataLines.map((line) => {
                const values = line.split(';');
                const row: DataRow = {};
                dataHeaders.forEach((key, i) => {
                    row[key] = values[i];
                });
                return row;
            });

            const frameIndices = getTotalFrames(dataObject);
            const xData: number[] = getUniqueXValues(dataObject);
            const yData: number[] = getUniqueYValues(dataObject);

            for (let i = 0; i < frameIndices.length; i++) {
                const frameData = dataObject.filter((row) => row['Beelden'] == frameIndices[i]);

                const matrix: number[][] = Array.from({ length: yData.length }, () =>
                    Array.from({ length: xData.length }, () => 0)
                );

                frameData.forEach((row) => {
                    const x = parseFloat(row.X);
                    const y = parseFloat(row.Y);

                    // const i = xData.indexOf(x);
                    // const j = yData.indexOf(y);
                    const i = findIndex(x, xData);
                    const j = findIndex(y, yData);

                    let val: number = 0;
                    if (fileName.includes('Mean')) val = parseInt(row['Gemiddelde druk (Kpa)']);
                    else if (fileName.includes('Max')) val = parseInt(row['Maximale druk (Kpa)']);
                    else if (fileName.includes('Video')) val = parseInt(row['Druk (Kpa)']);
                    matrix[j][i] = val;
                });

                const rawMat: Mat = matrixToMat(matrix);
                if (frameIndices.length === 1) {
                    if (isRight) setRightImage(rawMat);
                    else setLeftImage(rawMat);
                }
                else {
                    if (isRight) rightFrames.current.push(rawMat);
                    else leftFrames.current.push(rawMat);
                }
            }

            if (frameIndices.length > 1) {
                if (isRight) {
                    rightIntervalRef.current = setInterval(() => {
                        const rawData = rightFrames.current[rightCurrentFrame.current].clone();
                        setRightImage(rawData);
                        rightCurrentFrame.current++;
                        if (rightCurrentFrame.current === rightFrames.current.length)
                            rightCurrentFrame.current = 0
                    }, 100);
                }
                else {
                    leftIntervalRef.current = setInterval(() => {
                        const rawData = leftFrames.current[leftCurrentFrame.current].clone();
                        setLeftImage(rawData);
                        leftCurrentFrame.current++;
                        if (leftCurrentFrame.current === leftFrames.current.length)
                            leftCurrentFrame.current = 0;
                    }, 100);
                }
            }

        } catch (err) {
            console.error('Failed to load CSV: ', err);
        }
    };

    const handleUploadLeft = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log('Left File Input', event.target.files[0].name);
        const file = event.target.files?.[0];
        if (file) {
            loadCSV(file, file.name, false);
            setLeftFileName(file.name);
        }
    }

    const handleUploadRight = async (event: React.ChangeEvent<HTMLInputElement>) => {
        // console.log('Right File Input', event.target.files[0].name);
        // const file = event.target.files?.[0];
        // if (file) {
        //     loadCSV(file, file.name, true);
        //     setRightFileName(file.name);
        // }

        const files = Array.from(event.target.files);
        const requiredFiles = ['dMaxPLeft.csv', 'dMaxPRight.csv', 'dVideoLeft.csv', 'dVideoRight.csv'];

        // const filePath = files.map((f) => f.webkitRelativePath);

        const maxLeftFile = files.find((f) => f.name === requiredFiles[0]);
        const maxRightFile = files.find((f) => f.name === requiredFiles[1]);
        const videoLeftFile = files.find((f) => f.name === requiredFiles[2]);
        const videoRightFile = files.find((f) => f.name === requiredFiles[3]);

        if (!(maxLeftFile && maxRightFile && videoLeftFile && videoRightFile)) toast.error('Folder is missing required files');

        leftMaxFrameRef.current = (await readCSV(maxLeftFile, requiredFiles[0]))[0];
        rightMaxFrameRef.current = (await readCSV(maxRightFile, requiredFiles[1]))[0];
        leftFramesRef.current = await readCSV(videoLeftFile, requiredFiles[2]);
        rightFramesRef.current = await readCSV(videoRightFile, requiredFiles[3]);

        setRightImage(rightMaxFrameRef.current);
        setLeftImage(leftMaxFrameRef.current);

    }
    const convertImageSrcToFile = async (imageSrc: string, fileName: string): Promise<File> => {
        const response = await fetch(imageSrc);
        const blob = await response.blob();
        return new File([blob], fileName, { type: 'image/png' });
    };

    // Convert ImageData to Blob with optional downscaling and compression (default: JPEG 0.8)
    const imageDataToBlob = (
        imageData: ImageData,
        mime: string = 'image/jpeg',
        quality: number = 0.8,
        maxDim: number = 1024
    ): Promise<Blob> => {
        return new Promise((resolve, reject) => {
            try {
                const srcCanvas = document.createElement('canvas');
                srcCanvas.width = imageData.width;
                srcCanvas.height = imageData.height;
                const srcCtx = srcCanvas.getContext('2d');
                if (!srcCtx) return reject(new Error('Could not get canvas context'));
                srcCtx.putImageData(imageData, 0, 0);

                // compute scale to fit within maxDim
                const maxSide = Math.max(imageData.width, imageData.height);
                const scale = maxSide > maxDim ? maxDim / maxSide : 1;
                const dstWidth = Math.max(1, Math.round(imageData.width * scale));
                const dstHeight = Math.max(1, Math.round(imageData.height * scale));

                const dstCanvas = document.createElement('canvas');
                dstCanvas.width = dstWidth;
                dstCanvas.height = dstHeight;
                const dstCtx = dstCanvas.getContext('2d');
                if (!dstCtx) return reject(new Error('Could not get canvas context'));

                // draw scaled image
                dstCtx.drawImage(srcCanvas, 0, 0, dstWidth, dstHeight);

                dstCanvas.toBlob(
                    (blob) => {
                        if (blob) resolve(blob);
                        else reject(new Error('Failed to convert canvas to blob'));
                    },
                    mime,
                    quality
                );
            } catch (err) {
                reject(err);
            }
        });
    };

    // Save both images provided as ImageData
    const saveRondomImages = async (rightImageData: ImageData, leftImageData: ImageData) => {
        try {
            // compress/downscale to reduce upload size (use JPEG)
            const rightBlob = await imageDataToBlob(rightImageData, 'image/jpeg', 0.8, 1024);
            const leftBlob = await imageDataToBlob(leftImageData, 'image/jpeg', 0.8, 1024);

            const rightFile = new File([rightBlob], 'right_image.jpg', { type: 'image/jpeg' });
            const leftFile = new File([leftBlob], 'left_image.jpg', { type: 'image/jpeg' });

            const formData = new FormData();
            formData.append('leftFile', leftFile);
            formData.append('rightFile', rightFile);

            const designId = useSelectedDesignStore.getState().designId;
            const response = await api.put(`/api/designs/${designId}/rondomImage/`, formData);
            if (!response.ok) {
                toast.error('Failed to save images');
            }
        } catch (err) {
            console.error('Error saving images:', err);
            toast.error('Error saving images');
        }
    };


    const srcToImageData = (src: string): Promise<ImageData> => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymos';
            img.src = src;

            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;

                const ctx = canvas.getContext('2d');
                if (!ctx) {
                    reject(new Error('Could not get canvas context'));
                    return;
                }
                ctx.drawImage(img, 0, 0);
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                resolve(reverseImageData(imageData));
            }

            img.onerror = (err) => reject(err);
        });
    }

    const handleApply = async () => {
        // console.log("Rondom Apply");
        // useDesignStore.getState().importPressureImageData(rightRondomViewerRef.current?.getColorizeMat(), leftRondomViewerRef.current?.getColorizeMat());

        // if (!rightMaxFrameRef.current && !rightFramesRef.current && !leftMaxFrameRef.current && !leftFramesRef.current)
        //     onClose();

        // const pData = new PressureData();
        // pData.ExamType = 'dynamic';

        // let leftFrameIndex = [];
        // for (let i = 0; i < leftFramesRef.current.length; i++) {
        //     leftFrameIndex.push(i);
        // }
        // pData.FrameTimes_Left = leftFrameIndex;
        // pData.CalibMaxFrame_Left = leftMaxFrameRef.current;
        // pData.CalibFrames_Left = leftFramesRef.current;

        // let rightFrameIndex = [];
        // for (let i = 0; i < rightFramesRef.current.length; i++) {
        //     rightFrameIndex.push(i);
        // }

        // pData.FrameTimes_Right = rightFrameIndex;
        // pData.CalibMaxFrame_Right = rightMaxFrameRef.current;
        // pData.CalibFrames_Right = rightFramesRef.current;

        // pData.PressureSensorHeight = 7.62;
        // pData.PressureSensorWidth = 7.62;

        // pData.Save(); // TODO: this call throws an error without parameter! pass the correct data to save.
        // const event = new CustomEvent('newPressureScan', { detail: { pressureData: pData } });
        // document.dispatchEvent(event);

        

        if (!rightRondomViewerRef.current || !leftRondomViewerRef.current) return;
        let rightSrcImage = rightRondomViewerRef.current.getImageSrc();
        let leftSrcImage = leftRondomViewerRef.current.getImageSrc();

        if (!rightSrcImage && !leftSrcImage){
            toast.error('Both images are empty.');
            return;
        }
        else if (!rightSrcImage){
            toast.error('Right Image is empty.');
            return;
        }
        else if(!leftSrcImage){
            toast.error('Left Image is empty');
            return;
        }

        let rightImageData = await srcToImageData(rightSrcImage);
        let leftImageData = await srcToImageData(leftSrcImage);
        const rightPressureImage: PressureImage = {
            image: rightImageData,
            realHeight: rightImageData.height * RONDOM_PRESSUURE_PIXEL_WIDTH ,
            realWidth: rightImageData.width * RONDOM_PRESSUURE_PIXEL_WIDTH
        };

        const leftPressureImage: PressureImage = {
            image: leftImageData,
            realHeight: leftImageData.height * RONDOM_PRESSUURE_PIXEL_WIDTH,
            realWidth: leftImageData.width * RONDOM_PRESSUURE_PIXEL_WIDTH
        };
        const allImages: PressureImage[] = [];
        allImages.push(rightPressureImage);
        allImages.push(leftPressureImage);

        await saveRondomImages(rightImageData, leftImageData);

        useDesignStore.setState({RondomImageData: allImages});
        useSelectedDesignStore.setState({hasRondomImage: true});
        const event = new CustomEvent('newRondomImages');
        document.dispatchEvent(event);
        onClose();

    }

    const styles = {
        leftContainer: {
            gridRow: '2',
            gridColumn: '1',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            height: '60vh',
            width: '90%',
            backgroundColor: '',
            padding: '10px',
            borderRadius: '8px',
            marginLeft: '6%',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            position: 'relative',
            overflow: 'hidden',
        } as React.CSSProperties,

        rightContainer: {
            gridRow: '2',
            gridColumn: '2',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            height: '60vh',
            width: '90%',
            backgroundColor: '',
            padding: '10px',
            borderRadius: '8px',
            marginLeft: '4%',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            position: 'relative',
            overflow: 'hidden',
        } as React.CSSProperties,

        fileInputStyle: {
            display: 'inline-block',
            padding: '10px 16px',
            backgroundColor: '#007BFF',
            color: '#fff',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 500,
            textAlign: 'center',
            transition: 'background-color 0.2s ease',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        } as React.CSSProperties,

        selectContainer: {
            gridColumn: '1 / span 2',
            // gridRow: '3',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            // margin: '5px 0'
            marginTop: '10px',
            marginBottom: '3px'
        } as React.CSSProperties,

        buttonContainer: {
            gridColumn: '1 / span 2',
            // gridRow: '4',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            // margin: '10px 0',
            marginTop: '3px',
            marginBottom: '10px',
            maxHeight: '50px'
        } as React.CSSProperties,

        acceptButton: {
            padding: '10px 16px',
            backgroundColor: '#28a745',
            color: '#fff',
            borderRadius: '6px',
            border: 'none',
            cursor: 'pointer',
            fontSize: '18px',
            fontWeight: 500,
            transition: 'background-color 0.2s ease',
        } as React.CSSProperties,

        cancelButton: {
            padding: '10px 16px',
            backgroundColor: '#dc3545',
            color: '#fff',
            borderRadius: '6px',
            border: 'none',
            cursor: 'pointer',
            fontSize: '18px',
            fontWeight: 500,
            transition: 'background-color 0.2s ease',
        } as React.CSSProperties,

    };

    const getFileNameStyle = (fileName: string): React.CSSProperties => ({
        marginLeft: "12px",
        fontSize: "14px",
        color: "#555",
        fontStyle: fileName === "No file selected" ? "italic" : "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "250px",
        padding: '10px 16px',
    })

    const getThemeStyles = (isDarkMode: boolean): React.CSSProperties => ({
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'auto 1fr',
        marginTop: '-3%',
        gap: '10px',
        padding: '',
        paddingRight: '2px',
        paddingLeft: '2px',
        backgroundColor: isDarkMode ? 'rgb(51, 51, 51)' : 'white',
        height: '95vh',
    })

    return (
    <Modal open={isOpen} onClose={onClose} closeAfterTransition sx={{display: "flex", alignItems: "center", justifyContent: "center",}}>
      <Box
        sx={{
          bgcolor: isDarkMode ? '#333' : '#fff',
          color: isDarkMode ? '#fff' : '#000',
          borderRadius: 2,
          width: { xs: '95vw', md: '40vw' },
          maxHeight: { xs: '95vh', md: '80vh' }, 
          mx: 'auto',
          boxShadow: 24,
          outline: 'none',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 2,
            borderBottom: '1px solid #ccc',
          }}
        >
          <Typography variant="h6" sx={{ color: isDarkMode ? '#fff' : '#076596' }}>
            Rondom Scans
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon sx={{ color: isDarkMode ? '#fff' : '#000' }} />
          </IconButton>
        </Box>

        {/* Content */}
        <Box
        sx={{
            flexGrow: 1,
            p: 3,
            display: 'flex',
            gap: 3,
            justifyContent: 'center',
            alignItems: 'stretch',
            overflowY: 'auto',
        }}
        >
        {/* Left */}
        <Box
        sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            maxHeight: '100%',
            border: '1px solid',
            borderColor: isDarkMode ? '#555' : '#ddd',
            borderRadius: 2,
            overflow: 'hidden',
        }}
        >
        {/* Label */}
        <Box
            sx={{
            bgcolor: '#f0f0f0',
            color: '#000',
            textAlign: 'center',
            p: 1.2,
            borderBottom: '1px solid #ccc',
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            }}
        >
            <Typography variant="subtitle2" fontWeight={600}>
            Left Foot
            </Typography>
        </Box>

        {/* Viewer */}
        <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
            <RondonPressureViewerComponent
            ref={leftRondomViewerRef}
            mode="viewer"
            imgData={leftImage}
            />
        </Box>
        </Box>


        {/* Right */}
        <Box
        sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            maxHeight: '100%',
            border: '1px solid',
            borderColor: isDarkMode ? '#555' : '#ddd',
            borderRadius: 2,
            overflow: 'hidden',
        }}
        >
        {/* Label */}
        <Box
            sx={{
            bgcolor: '#f0f0f0',
            color: '#000',
            textAlign: 'center',
            p: 1.2,
            borderBottom: '1px solid #ccc',
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            }}
        >
            <Typography variant="subtitle2" fontWeight={600}>
            Right Foot
            </Typography>
        </Box>

        {/* Viewer */}
        <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
            <RondonPressureViewerComponent
            ref={rightRondomViewerRef}
            mode="viewer"
            imgData={rightImage}
            />
        </Box>
        </Box>
        </Box>

        {/* Footer */}
        <Box
          sx={{
            p: 2,
            borderTop: '1px solid #ccc',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1,
          }}
        >
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              color: isDarkMode ? '#fff' : '#000',
              borderColor: '#aaa',
              width: '80px',
              fontWeight: 500,
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleApply}
            sx={{
              color: '#fff',
              backgroundColor: '#076596',
              width: '80px',
              fontWeight: 500,
              px: 4,
              '&:hover': { backgroundColor: '#0a6fb4' },
            }}
          >
            Accept
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RondomScanViewer;